<app-loader></app-loader>

<div class="login-page">
  <div class="login-page__overlay"></div>

  <div class="login-page__content">
    <div class="login-card">
      <div class="login-card__header">
        <div class="brand">
          <img
            src="Logo/logo-opt.webp"
            alt="Casinoze Logo"
            class="brand__logo-img"
          />
        </div>

        <button
          type="button"
          class="login-card__close"
          (click)="closeLogin()"
          aria-label="Close login form"
        >
          &times;
        </button>
      </div>

      <div class="login-card__title">
        <h1>WELCOME BACK</h1>
        <p>Sign in to your account to continue playing.</p>
      </div>

      <form
        [formGroup]="loginForm"
        (ngSubmit)="loginUser()"
        autocomplete="off"
        class="login-form"
      >
        <div class="form-group">
          <label for="username" class="field-label">EMAIL OR USERNAME</label>
          <div class="input-group">
            <i class="fas fa-user"></i>
            <input
              type="text"
              id="username"
              formControlName="username"
              placeholder="you@example.com"
              class="login-input"
            />
          </div>
          <div
            *ngIf="
              loginForm.get('username')?.invalid &&
              loginForm.get('username')?.touched
            "
            class="error-text"
          >
            Username or email is required.
          </div>
        </div>

        <div class="form-group">
          <label for="password" class="field-label">PASSWORD</label>
          <div class="input-group">
            <i class="fas fa-lock"></i>
            <input
              [type]="showpassword ? 'text' : 'password'"
              id="password"
              formControlName="userPassword"
              placeholder="••••••••"
              class="login-input"
            />
            <fa-icon
              class="password-toggle"
              (click)="togglePassword()"
              [icon]="showpassword ? hideicon : showicon"
            ></fa-icon>
          </div>
          <div
            *ngIf="
              loginForm.get('userPassword')?.invalid &&
              loginForm.get('userPassword')?.touched
            "
            class="error-text"
          >
            Password is required.
          </div>
        </div>

        <div class="login-options">
          <label class="remember-label">
            <input
              type="checkbox"
              formControlName="rememberMe"
              class="remember-checkbox"
            />
            <span class="cb-box">
              <svg
                class="cb-check"
                width="9"
                height="7"
                viewBox="0 0 9 7"
                fill="none"
              >
                <path
                  d="M1 3.5L3.5 6L8 1"
                  stroke="#080c10"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            Remember me
          </label>
          <button
            type="button"
            class="forgot-link-button"
            (click)="requestForgotPassword($event)"
          >
            Forgot?
          </button>
        </div>

        <button
          type="submit"
          [disabled]="loginForm.invalid"
          class="primary-button"
        >
          SIGN IN
          <svg
            class="signin-arrow"
            width="13"
            height="13"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            stroke-width="2.5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
            />
          </svg>
        </button>
      </form>

      <div class="social-divider">
        <span>OR</span>
      </div>

      <button
        type="button"
        (click)="continueWithGoogle($event)"
        class="google-button"
      >
        <img
          src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
          alt="Google logo"
        />
        Continue with Google
      </button>

      <p class="signup-text">
        No account?
        <button
          type="button"
          class="signup-link-button"
          (click)="requestSignUp($event)"
        >
          Create one free →
        </button>
      </p>
    </div>
  </div>
</div>
